var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-panel in-modal"},[_vm._t("search"),_c('FabricTransitionHeight',[_c('article',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isTablet  || (_vm.isTablet && !_vm.filtersHidden)),expression:"!isTablet  || (isTablet && !filtersHidden)"}]},[_vm._t("extra-filters")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }